import React from 'react';

const TermsOfUse = () => (
  <div className="min-h-screen bg-slate-50 dark:bg-slate-950 py-20 px-6">
    <div className="container mx-auto max-w-4xl bg-white dark:bg-slate-900 p-8 md:p-12 rounded-3xl shadow-sm border border-slate-100 dark:border-slate-800">
      <h1 className="text-4xl font-black mb-8 text-slate-800 dark:text-white">Termos de Uso</h1>
      <div className="prose prose-slate dark:prose-invert max-w-none space-y-6 text-slate-600 dark:text-slate-400">
        <p>Ao acessar o site Emprega Mais Rondônia, você concorda em cumprir estes termos de serviço.</p>
        <h2 className="text-2xl font-bold text-slate-800 dark:text-white">1. Isenção de Responsabilidade</h2>
        <p>As vagas publicadas são de responsabilidade das empresas anunciantes. O portal atua apenas como facilitador de divulgação.</p>
        <h2 className="text-2xl font-bold text-slate-800 dark:text-white">2. Uso de Conteúdo</h2>
        <p>É proibido o uso de técnicas de "scraping" ou cópia automatizada das vagas para outros portais sem autorização prévia.</p>
      </div>
    </div>
  </div>
);

export default TermsOfUse;